import React, { useCallback, useEffect, useState } from "react";
import SettlementCalendarHeader from "../../../components/master/settlementCalendar/SettlementCalendarHeader.jsx";
import Breadcrumbs from "../../../components/ui/Breadcrumbs.jsx";
import SettlementCalendarConfig from "./SettlementCalendarConfig.jsx";
import axios from "axios";
import { errorNotify, successNotify } from "../../../Services/Notification.js";
import SettlementCalendarUpload from "../../../components/master/settlementCalendar/SettlementCalendarUpload.jsx";

const getSettlementCalendarAPIURL = `${process.env.REACT_APP_API_URL}api/list-settlement-calender/`;
const SettlementCalendar = () => {
  const [renderKey, setRenderKey] = useState(0);
  const [data, setData] = useState([]);
  const [filter, setFilter] = useState();
  const [loading, setLoading] = useState();
  const [isPopupOpen, setisPopupOpen] = useState();

  const triggerRerender = () => {
    setRenderKey((prev) => prev + 1);
  };
  // API CONFIG
  const headers = {
    Authorization: `Bearer ${
      sessionStorage.getItem("subscriberToken")
        ? sessionStorage.getItem("subscriberToken")
        : sessionStorage.getItem("token")
    }`,
    "Content-Type": "application/json",
  };

  const getSettlementCalendar = async () => {
    setLoading(true);
    try {
      if (filter?.bookclose_recorddate && filter?.nse_exdate) {
        const payload = {
          start_date: filter?.bookclose_recorddate,
          end_date: filter?.nse_exdate,
        };

        const res = await axios.post(getSettlementCalendarAPIURL, payload, {
          headers,
        });
        if (res.data.success) {
          const formatedDateData = res.data?.data?.map((item) => ({
            ...item,
          }));

          setData(formatedDateData);
          setLoading(false);
        } else {
          errorNotify(res.data.message);
          setLoading(false);
        }
      } else if (filter?.bookclose_recorddate && !filter?.nse_exdate) {
        errorNotify("Please select end date");
      } else if (!filter?.bookclose_recorddate && filter?.nse_exdate) {
        errorNotify("Please select start date");
      } else if (!filter?.bookclose_recorddate && !filter?.nse_exdate) {
        errorNotify("Please select start and end date");
      }
      setLoading(false);
    } catch (err) {
      errorNotify("Something went wrong");
      setLoading(false);
    }
  };

  useEffect(() => {
    if (filter?.bookclose_recorddate || filter?.nse_exdate) {
      getSettlementCalendar();
    } else if (!filter) {
      setData([]);
      setLoading(false);
    }
  }, [filter?.bookclose_recorddate, filter?.nse_exdate, renderKey]);

  const breadcrumbs = ["Home", "Master", "Settlement Calendar"];

  return (
    <div className=" app-container min-h-[65vh] pb-[60px] pt-[100px]">
      <div className="flex justify-between">
        <Breadcrumbs items={breadcrumbs} />
      </div>

      <SettlementCalendarHeader
        setisPopupOpen={setisPopupOpen}
        setFilter={setFilter}
      />
      <SettlementCalendarConfig tableData={data} loading={loading} />
      {isPopupOpen && (
        <SettlementCalendarUpload
          triggerRerender={triggerRerender}
          setisPopupOpen={setisPopupOpen}
        />
      )}
    </div>
  );
};

export default SettlementCalendar;
